/**
 *    Gallery teaser
 */

(function ($) {
  Drupal.behaviors.galleryTeaser = {
    attach() {
      // init every gallery with a owl carousel
      $('.vb-gallery--teaser').each((i, e) => {
        const $gallery = $(e);
        const $gallaryImageThumbs = $gallery.find('.vb-gallery__image');
        const $gallaryImageThumbsLink = $gallaryImageThumbs.find('a');
        const $galleryCarousel = $gallery.find('.vb-gallery__carousel');

        // set a target number to every thumbnail link
        $gallaryImageThumbsLink.each((index, element) => {
          const $link = $(element);
          $link.attr({
            'data-target-number': index,
            role: 'button',
            'aria-label': `${Drupal.t('Thumbnail for image number')} ${index}`,
          });
        });

        // append image to the carousel container
        $gallaryImageThumbs.each((index, element) => {
          const $thumb = $(element);
          const $thumbLink = $thumb.find('a');
          const $thumbImg = $thumb.find('img');
          const src = $thumbLink.attr('href');
          const alt = $thumbImg.attr('alt') ? $thumbImg.attr('alt') : '';
          const title = $thumbImg.attr('title') ? $thumbImg.attr('title') : '';
          const copyright = $thumb.data('copyright');

          // create image and append it
          $galleryCarousel.append(
            '<figure>'
              + `<img src="${src}" alt="${alt}" title="${title}" loading="lazy">`
              + '<div class="vb-image-caption">'
                  + `&copy; ${copyright}${title ? (` (${title})`) : ''
                  }</div>`
          + '</figure>',
          );
        });

        // thumbnail bahavior
        $galleryCarousel.on('changed.owl.carousel', (event) => {
          // mark active thumbnail items
          $gallaryImageThumbsLink.removeClass('vb-active');
          $($gallaryImageThumbsLink.get(event.item.index)).addClass('vb-active');

          // scroll thumbnails
          $('.vb-gallery__images')[0].scrollTo({
            left: $($gallaryImageThumbsLink.get(event.item.index)).closest('.vb-gallery__item').position().left - 100,
            behavior: 'smooth',
          });
        });

        if ($gallaryImageThumbsLink.length < 4) {
          $gallery.find('.vb-gallery__images').addClass('vb-hidden');
        }

        // init owl carousel with parameters
        $galleryCarousel.addClass('owl-carousel').owlCarousel({
          items: 1,
          stageElement: 'ul',
          itemElement: 'li',
          nav: true,
          navText: ['', ''],
          dots: false,
          onInitialized() {
            // a11y
            $galleryCarousel.find('.owl-prev')
              .attr('aria-label', Drupal.t('Previous'))
              .removeAttr('role');
            $galleryCarousel.find('.owl-next')
              .attr('aria-label', Drupal.t('Next'))
              .removeAttr('role');
          },
        });

        // click on a carousel thumbnail
        $gallaryImageThumbsLink.on('click', function (event) {
          event.preventDefault();

          // get target number
          const targetNumber = $(this).data('target-number');

          // Parameters has to be in square bracket '[]'
          $galleryCarousel.trigger('to.owl.carousel', [targetNumber]);
        });
      });
    },
  };
}(jQuery));

// end of gallery-teaser.js
